export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/RealSimple.1dc326b1.svg","height":22,"width":192};